export default "__VITE_ASSET__Biz_0DzV__"